module.exports = __webpack_public_path__ + "static/img/2.e9dacd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/2.jpg
// module id = zv6t
// module chunks = 16